import React, { Component } from 'react'
import { translate } from '../utils/useful'

export default class PageBuilderHeader extends Component {
    state = {

    }



    render() {
        return (
            <div className='p-3 flexcb w-100 window-content-radius' style={{ borderBottom: "1px solid #eee", backgroundColor: "#fff" }}>
                <div className='flexc'>
                    <button className='br-5 flexcc' style={{ backgroundColor: "#2872e1", width: "30px", height: "30px" }}>
                        <p className='p-2 white weight-300 font-size-16'>GI</p>
                    </button>
                    <button className='mld-2 flexc'>
                        <p className='font-size-12' style={{ color: "#555" }}>Gedrich Interface</p>
                        <img width={22} src='/assets/icons/pagebuilder/arrow-down-black.svg' />
                    </button>
                </div>
                <div className='flexc'>
                    <button className='share-btn br-20 px-3 flexcc mrd-4' style={{ height: "30px" }} onClick={() => this.props.getPage()}>
                        <p className='font-size-14'>{translate('save')}</p>
                    </button>
                    <button className='btn-box mrd-4'>
                        <img src='/assets/icons/pagebuilder/bell.svg' />
                    </button>
                    <button className='br-20 flexcc' style={{ backgroundColor: "#f5f5f5", width: "30px", height: "30px", border: "1px solid #2872e1" }}>
                        <p className='p-2 weight-300 font-size-16' style={{ color: "#2872e1" }}>H</p>
                    </button>
                </div>
            </div>
        )
    }
}
